import { HostAssistantError } from '../../../services/host-assistant-client';

export interface AssistantError {
  code: string;
  message: string;
  /** Whether asking the same question again could plausibly work. */
  retryable: boolean;
}

const FIXED: Record<string, { message: string; retryable: boolean }> = {
  host_assistant_unconfigured: { message: "Ask Tripsby isn't set up yet for Studio.", retryable: false },
  forbidden: { message: "You don't have access to this group's assistant.", retryable: false },
  group_not_found: { message: "This group couldn't be found.", retryable: false },
  rate_limited: { message: 'Too many questions at once — try again in a minute.', retryable: true },
  invalid_request: {
    message: "That question couldn't be sent. Try shortening it, or start a new conversation.",
    retryable: false,
  },
  // The client has already cleared the session and is sending the host to /login.
  unauthorized: { message: 'Your session expired. Taking you to sign in…', retryable: false },
  aborted: { message: 'Stopped.', retryable: true },
  timeout: { message: 'Ask Tripsby took too long to answer. Try again.', retryable: true },
  network: { message: "Couldn't reach Ask Tripsby. Check your connection and try again.", retryable: true },
};

export function describeError(err: unknown): AssistantError {
  const code = err instanceof HostAssistantError ? err.code : 'network';
  const fixed = FIXED[code];
  if (fixed) return { code, ...fixed };
  // An `error` frame from the model side: trust its message, offer a retry.
  const serverMessage = err instanceof HostAssistantError && err.message ? err.message : null;
  return { code, message: serverMessage ?? 'Ask Tripsby ran into a problem. Try again.', retryable: true };
}
